<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Jackson Hole</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">Many thanks to the staff at the Wyoming State Archives, the American Heritage Center at the University of Wyoming, and the Marriott Library at the University of Utah. Thanks are also due to anyone who cares about Wyoming history and takes a moment to consider how the past has given us the world we inhabit today.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?0c551263